import { PaymentCard, RaffleSimple } from '@core/models';

export class OrderSubscriptionData {
  order_id: number;
  price: string;
  currency: string;
  ticket_numbers: string[];
  status: string;
}
export class OrderSubscription {
  [id: number]: OrderSubscriptionData[];
}

export class CycleSubscription {
  order: OrderSubscriptionData;
  raffle: RaffleSimpleSubscription;
}

export class RaffleSimpleSubscription {
  id: number;
  title: string;
  start_at: string;
  result_at: string;
  end_at: string;
  slug: string;
  end_prize_name: string;
  linked_competition: LinkedCompetition;
  category_ids: string[];
}

export class SubscriptionOption {
  id: number;
  active: boolean;
  defaultActive: boolean;
  isHouseOrProperty: boolean;
  delay_billing_date: DelayedUserSubscription;
  periodDescription: string;
  end_at: string;
  discount_percentage: number;
}

export class LinkedCompetition {
  id: number;
  title: string;
  slug: string;
  user_has_tickets: boolean;
}

export class RaffleInformation {
  raffle: RaffleSimple;
  subscriptions: UserSubscription[];
}

export class Subscription {
  id: number;
  title: string;
  status: SubscriptionStatus;
  start_date: string;
  end_data: string;
  period_adverb: SubscriptionPeriodAdverb;
  period_description: SubscriptionPeriodDescription;
  current_raffle: RaffleSimpleSubscription;
  previous_raffles: RaffleSimpleSubscription[];
  status_messages: string[];
  discount_percentage: number;
}

export class UserSubscription {
  id: number;
  subscription: Subscription;
  ticket_quantity: number;
  status: UserSubscriptionStatus;
  start_date: string;
  end_date: string;
  payment_card: PaymentCard;
  status_messages: string[];
  orders: OrderSubscription;
  delayed_user_subscription: DelayedUserSubscription;
}

export class DelayedUserSubscription {
  billing_date: string;
}

export class SubscriptionInfoDialogData {
  raffleId: number;
  subscriptionOption: SubscriptionOption;
}

export enum SubscriptionPeriodDescription {
  Minutes = '15 minutes',
  Week = 'week',
  Month = 'month',
  TwoWeeks = '2 weeks'
}

export enum SubscriptionPeriodAdverb {
  Week = 'weekly',
  Month = 'monthly',
  TwoWeeks = 'every 2 weeks'
}

export enum UserSubscriptionStatus {
  Active = 'active',
  Suspended = 'suspended',
  Cancelled = 'cancelled'
}

export enum SubscriptionStatus {
  Active = 'active',
  Inactive = 'inactive',
  Cancelled = 'cancelled',
  Suspended = 'suspended'
}

export interface IntervalRange {
  min: number;
  max: number;
}

export const subscriptionLimits: Record<
  SubscriptionPeriodDescription,
  IntervalRange
> = {
  [SubscriptionPeriodDescription.Week]: { min: 1, max: 50 },
  [SubscriptionPeriodDescription.TwoWeeks]: { min: 1.99, max: 100 },
  [SubscriptionPeriodDescription.Month]: { min: 1, max: 200 },
  [SubscriptionPeriodDescription.Minutes]: { min: 1, max: 2000 }
};
